export default __webpack_public_path__ + "eec809fb969bd26d396eaee500aa5ad4.png";